import { ActionReducer, MetaReducer } from '@ngrx/store';
import {
  authenticationActions,
  AuthenticationState,
  authenticationStateKey,
} from '@redux/authentication.redux';
import { communityStateKey } from '@redux/community.effects';
import { CommonState } from '@redux/common/common.state';
import { Community } from '@models/customer/community.model';
import { CatalogState, catalogStateKey } from '@redux/catalog.redux';
import { CrosscuttingState, crosscuttingStateKey } from '@redux/crosscutting.redux';
import { AnnouncementsState, announcementsStateKey } from '@redux/announcements.effects';
import { GalleryState, galleryStateKey } from '@redux/gallery.effects';
import { DiningState, diningStateKey } from '@redux/dining.effects';
import { ResidentsState, residentsStateKey } from '@redux/directory.effects';
import { SurveysState, surveysStateKey } from '@redux/surveys.effects';
import { EventsState, eventsStateKey } from '@redux/events.effects';
import { UserState, userStateKey } from '@redux/user.effects';
import { NotificationsState, notificationsStateKey } from '@redux/notifications.redux';
import { ServiceRequestsState, serviceRequestsStateKey } from '@redux/service-requests.effects';
import { CorporationState, corporationStateKey } from '@redux/corporation.effects';

export interface ApplicationState {
  [communityStateKey]: CommonState<Community>;
  [authenticationStateKey]: AuthenticationState;
  [catalogStateKey]: CatalogState;
  [crosscuttingStateKey]: CrosscuttingState;
  [announcementsStateKey]: AnnouncementsState;
  [galleryStateKey]: GalleryState;
  [diningStateKey]: DiningState;
  [residentsStateKey]: ResidentsState;
  [notificationsStateKey]: NotificationsState;
  [surveysStateKey]: SurveysState;
  [eventsStateKey]: EventsState;
  [userStateKey]: UserState;
  [serviceRequestsStateKey]: ServiceRequestsState;
  [corporationStateKey]: CorporationState;
}
export function clearStateMetaReducer(
  reducer: ActionReducer<ApplicationState>,
): ActionReducer<ApplicationState> {
  return function (state, action) {
    if (action.type === authenticationActions.logoutSuccess.type) {
      state = undefined;
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<ApplicationState>[] = [clearStateMetaReducer];
